import React from "react";

export function SkipTranslate({ children }: { children: React.ReactNode }) {
  return (
    <div className="notranslate" translate="no">
      {children}
    </div>
  );
}
